import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { IconButton, MenuItem } from "@mui/material";
import axios from "axios";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";

import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
// import { PlusIcon } from "../../../../common/imagePath";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";
import InventorySubModulesRecordsModal from "../../../../components/Modal/InventorySubModulesRecordsModal";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "add-manufacturers";
let PERMISSION_EDIT = "edit-manufacturers";
let PERMISSION_DELETE = "delete-manufacturers";

const Manufacturers = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const [formValues, setFormValues] = useState({ ID: 0, Name: "" });
  const [filtertext, setFiltertext] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState([]);

  ///----------server side-------

  const [isError, setIsError] = useState(false);
  // const [globalFilter, setGlobalFilter] = useState("");
  // const [columnFilters, setColumnFilters] = useState([]);
  const [modal, setModal] = useState(false);
  // const [sorting, setSorting] = useState([]);
  // const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [runApi, setRunApi] = useState(false);
  const [manufacturerName, setManufacturerName] = useState('');
  const [moduleID, setModuleId] = useState(0);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Manufacturer name is required"),
  });

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  // Get all Manufacturers data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorderabb,
    pagination,
    currentorder
  ) => {
    setLoading(true);

    // const FilterColumnText = {};

    // FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
    //   return {
    //     columnname: el.id,
    //     value: el.value,
    //     id: index + 1,
    //     // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
    //   };
    // });

    // let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // // const columnIndex = columns.findIndex(
    // //   (column) => column.accessorKey === currentorder[0]?.id
    // // );
    // const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        `${
          config.manufacturerBaseUrl
        }/manufacturers?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagenumber=&pagesize=&filtertext=`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        // setRowCount(res.data.ResponseData[0].TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    handleListData();
  }, []);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.manufacturerBaseUrl}/manufacturers/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const manufacturerData = res.data.ResponseData[0];
        console.log(manufacturerData);

        const data = { ID: manufacturerData.ID, Name: manufacturerData.Name };
        setFormValues(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Crete and Update Manufacturer

  // const handleSubmit = async (eventObject) => {
  //   console.log(eventObject, "Manufacturer Name");
  //   setLoading(true);
  //   axios
  //     .post(
  //       `${config.manufacturerBaseUrl}/manufacturers/upsert`,
  //       {
  //         id: eventObject.ID,
  //         isactive: 1,
  //         name: eventObject.Name,
  //         loginuserid: loginUserId,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         toastSuccess(SUCCESS_MESSAGE);
  //         handleListData();
  //         setLoading(false);
  //         window.location.reload();
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //       ) {
  //         toastError(ERROR_EXISTS);

  //         setLoading(false);
  //       } else {
  //         toastError(ERROR_MESSAGE);
  //         setLoading(false);
  //       }
  //     });
  // };

  const handleSubmit = async (values) => {
    setLoading(true);
    axios
      .post(
        `${config.manufacturerBaseUrl}/manufacturers/upsert`,
        {
          id: values.ID > 0 ? values.ID : 0,
          isactive: 1,
          name: values.Name,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();
          setLoading(false);
          // window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    console.log(values, row, "handleSaveRow");
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    data[row.index] = values;
    // //send/receive api updates here
    setData([...data]);
    axios
      .post(
        `${config.manufacturerBaseUrl}/manufacturers/upsert`,
        {
          id: row.original.ID,
          isactive: 1,
          name: values.Name,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // handleListData();
          setLoading(false);
          // window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });

    exitEditingMode(); //required to exit editing mode
  };

  // Delete Manufacturer
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  // const handleManageDataPopup = () => {
  //   const clearData = { ID: 0, Name: "" };
  //   setFormValues(clearData);
  // };

  const handleManageDataPopup = (id = 0, name = "") => {
    const formData = { ID: id, Name: name };
    setFormValues(formData);
  };

  // Table Data
  const columns = [
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <>
    //       <div class="btn-group-sm" role="group">
    //         {checkUserPermission(PERMISSION_EDIT) ? (
    //           <Link
    //             className="btn btn-primary btn-sm btn-custom-padding"
    //             to="#"
    //             data-bs-toggle="modal"
    //             data-bs-target="#ManageDataModal"
    //             data-backdrop="static"
    //             data-keyboard="false"
    //             onClick={() => handleUpdate(row.ID)}
    //           >
    //             Edit
    //           </Link>
    //         ) : (
    //           ""
    //         )}
    //         {checkUserPermission(PERMISSION_DELETE) ? (
    //           <Link
    //             className="btn btn-primary btn-sm btn-custom-padding confirm-text ml-2"
    //             to="#"
    //             title="Delete"
    //             data-bs-toggle="modal"
    //             data-bs-target="#DeleteConfirmationModal"
    //             onClick={() => handleDeletePopup(row.ID)}
    //           >
    //             Delete
    //           </Link>
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     </>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   //width: "7%",//"100px",
    //   // minWidth: "100px",
    //   width: "200px",
    // },
    // {
    //   name: "Manufacturers",
    //   // selector: "Name",
    //   selector: (row) => (
    //     <p className="word-break-data" title={row.Name}>
    //       {row.Name}
    //     </p>
    //   ),
    //   sortable: true,
    //   // minWidth: "190px",
    //   // width: "200px",
    // },
    // // {
    // //   name: "Action",
    // //   width: "20%",
    // //   cell: (row) => (
    // //     <>
    // //       {/* Edit Record Button  */}
    // //       {checkUserPermission(PERMISSION_EDIT) ? (
    // //         <Link
    // //           className="me-3"
    // //           to="#"
    // //           data-bs-toggle="modal"
    // //           data-bs-target="#ManageDataModal"
    // //           data-backdrop="static"
    // //           data-keyboard="false"
    // //           onClick={() => handleUpdate(row.ID)}
    // //         >
    // //           <i class="fa fa-edit text-warning fa-2x" title="Edit"></i>
    // //         </Link>
    // //       ) : (
    // //         ""
    // //       )}

    // //       {/** Delete Record Button */}
    // //       {checkUserPermission(PERMISSION_DELETE) ? (
    // //         <Link
    // //           className="confirm-text"
    // //           to="#"
    // //           title="Delete"
    // //           data-bs-toggle="modal"
    // //           data-bs-target="#DeleteConfirmationModal"
    // //           onClick={() => handleDeletePopup(row.ID)}
    // //         >
    // //           <i
    // //             class="fa fa-trash text-red fa-2x"
    // //             data-bs-toggle="tooltip"
    // //             title="Delete"
    // //           ></i>
    // //         </Link>
    // //       ) : (
    // //         ""
    // //       )}
    // //     </>
    // //   ),
    // //   ignoreRowClick: true,
    // //   allowOverflow: true,
    // //   button: true,
    // // },
    {
      header: "Manufacturers",
      accessorKey: "Name",
    },
    
    {
      header: "Manufacturer Count",
      accessorKey: "Count",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          }}
          onClick={() => {setRunApi(true) 
            setModuleId(row.original.ID);
            setManufacturerName(row.original.Name);
          }} 
        >
          {row.original.Count}
        </Box>
      ),
    },

  ];

  const [columnOrder, setColumnOrder] = useState(
    ['mrt-row-select', ...columns.map((c) => c.accessorKey),'mrt-row-actions',], //array of column ids (Initializing is optional as of v2.10.0)
  );

  // const renderRowActionMenuItems=({ row, table }) =>  [
  //   checkUserPermission(PERMISSION_EDIT) ? ( 
   
  //     <MenuItem
  //       data-bs-toggle="modal"
  //       data-bs-target="#ManageDataModal"
  //       data-backdrop="static"
  //       data-keyboard="false"
  //       key="edit"
  //       onClick={() =>  {handleManageDataPopup(row.original.ID,row.original.Name)}}
  //     >
  //     {/* <EditIcon /> */}
  //        Edit
  //     </MenuItem>
  //   ) : (
  //     ""
  //   ),
  //   checkUserPermission(PERMISSION_DELETE) ? (
  //     <MenuItem
  //       className="confirm-text"
  //       to="#"
  //       key="delete"
  //       onClick={() => handleDeletePopup(row.original.ID)}
  //     >
  //      {/* <DeleteIcon />  */}
  //       Delete
  //     </MenuItem>
  //   ) : (
  //     ""
  //   ),
  // ]

  const renderRowActions = ({ row }) => {
    const { original } = row;
    return (
      <div>
        {checkUserPermission(PERMISSION_EDIT) && (
          <button 
            className="btn btn-primary btn-md me-2 mt-1 mb-1 ms-1 pull-left"
            data-bs-toggle="modal"
            data-bs-target="#ManageDataModal"
            data-backdrop="static"
            data-keyboard="false"
            key="edit"
            onClick={() =>  {handleManageDataPopup(original.ID, original.Name)}}>
            Edit
          </button>
        )}
        {checkUserPermission(PERMISSION_DELETE) && (
          <button
            className="btn btn-dark btn-md mt-1 mb-1 me-2 confirm-text"
            to="#"
            key="delete"
            onClick={() => handleDeletePopup(row.original.ID)}
          >
            Delete
          </button>
        )}
      </div>
    );
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, filtertext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPage, filtertext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPage, filtertext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setFiltertext(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };

  console.log(rowSelectData,"rowSelectData")

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Items: Manufacturers</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Manufacturers</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 "
                onChange={ChangeFilterText}
                value={filtertext}
              /> */}
            </div>
            <div className="col-md-4">
                {rowSelectData?.length > 0 && (
                  <button
                    className="btn btn-dark btn-sm mt-1"
                    onClick={() => handleDeletePopup(rowSelectData.join(','))}
                  >
                    Delete Selected
                  </button>
                )}
              </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  {/* <img src={PlusIcon} alt="img" className="me-1" />
                   */}
                  <i className="fa fa-plus me-2 lg"></i>
                  Add Manufacturer
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Data list */}
          {/* <div className="row">
            <div className="row flex-row-reverse">
              <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-50 pull-right"
                  onChange={ChangeFilterText}
                  value={filtertext}
                />
              </div>
            </div>
          </div> */}
          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                <CommonMatrialReactTable
                columns={columns}
                data={data}
                hodiExport={false}
                enableRowSelection={true}
                enableRowActions={true}
                // rowActionsType="menu"
                renderRowActions={renderRowActions}
                isRowSelectionManual={true}
                setRowSelectData={setRowSelection}
                setColumnOrder={setColumnOrder}
                state={{columnOrder, rowSelection,}}
                columnsToExport={["ID", "Name", "Count", "CreatedDate"]}
                // renderRowActionMenuItems={renderRowActionMenuItems}
              />
              

                  {/* <MaterialReactTable
                  columns={columns}
                  data={data}
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableColumnOrdering
                  enableRowActions={checkUserPermission(PERMISSION_DELETE)|| checkUserPermission(PERMISSION_EDIT)}
                  positionGlobalFilter="left"
                  editDisplayMode="row"
                  enableEditing={checkUserPermission(PERMISSION_EDIT)}
                  onEditingRowSave={handleSaveRow}
                  renderRowActionMenuItems={({ row, table }) =>  [
                      checkUserPermission(PERMISSION_DELETE) ? (
                        
                        <MenuItem
                          className="confirm-text"
                          to="#"
                          key="delete"
                          // title="Delete"
                          // data-bs-toggle="modal"
                          // data-bs-target="#DeleteConfirmationModal"
                          // onClick={() => handleDeletePopup(row.original.Id)}
                          // data-bs-toggle="modal"
                          // data-bs-target="#DeleteConfirmationModal"
                          onClick={() => handleDeletePopup(row.original.ID)}
                        >
                         <DeleteIcon /> 
                          Delete
                        </MenuItem>
                      ) : (
                        ""
                      ),
                    ]}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* <Button
                          size="small"
                          onClick={() =>
                            // setPagination({ ...pagination, pageSize: totalRows })
                            setPagination({
                              ...pagination,
                              pageIndex: 0,
                              pageSize: rowCount,
                            })
                          }
                          variant="contained"
                        >
                          Get All Data
                        </Button> 
                      </Box>
                    )}
                    // rowVirtualizerOptions={{
                    //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                    //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                    // }}
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    initialState={{
                      density: "comfortable",
                      showGlobalFilter: true,
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 10 },
                      // sorting: { id: "Name", desc: false }, //sort by state by default
                    }}
                    //For color of each alternative row(Zebra-column)
                    muiTableBodyProps={{
                      sx: () => ({
                        "& tr:nth-of-type(even)": {
                          backgroundColor:
                            "var(--datatable-row-background-color)",
                          //'rgb(237 237 233 / 63%)'
                        },
                        "& td": {
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },

                        "& tr": {
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },
                      }),
                    }}
                    muiPaginationProps={{
                      rowsPerPageOptions: [10, 25, 50, 100, 300],
                    }}
                    // For providing color to header of table
                    muiTableHeadCellProps={{
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      // isError
                      // ? {
                      //   color: "error",
                      //   children: "Error loading data",
                      // }
                      // : undefined
                      {
                        isError: () => ({
                          color: "error",
                          children: "Error loading data",
                        }),
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }
                    }
                    muiSelectCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiSelectAllCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                    onGlobalFilterChange={setFiltertext}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    // enableColumnVirtualization={false}

                    // enableColumnVirtualization

                    state={{
                      columnFilters, // for termp comment filteron column
                      filtertext,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }} 
                  />
                  */}
                </div>
              </div>
            </div>
          </div>
          {/* /Data list */}
        </div>
      </div>
      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Manage Manufacturers</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={formValues?.ID}
                        />
                        <div className="form-group">
                          <label className="col-form-label p-lg-medium">
                            Manufacturer Name
                          </label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${
                              errors.Name ? "is-invalid" : ""
                            } form-control form-control-sm`}
                            placeholder="Enter Manufacturer Name"
                            value={formValues?.Name}
                            onChange={(e) => setFormValues({...formValues, Name:e.target.value})}
                            // onBlur={handleBlur}
                            // onChange={handleChange}
                          />
                          <div className="invalid-feedback">
                            {touched.Name && errors.Name ? errors.Name : ""}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* Upset Model  */}
      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.manufacturerBaseUrl}/manufacturers/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      `
      <InventorySubModulesRecordsModal
        Module="Manufacturer"
        runApi={runApi}
        closepopup={() => {setRunApi(false); setModuleId(0); handleListData();}}
        ModuleId={moduleID}
        Name={manufacturerName}
        columnsToExport={["ID", "Item", "Name", "ImageName", "CreatedDate", "ItemId", "ItemVariationId", "ManufacturerID", "Manufacturer"]}
      />
    </>
  );
};

export default Manufacturers;
